import React from 'react';
import { X } from 'lucide-react';

interface CustomModalProps {
  show: boolean;
  onHide: () => void;
  title: string | React.ReactNode;
  children: React.ReactNode;
  footer?: React.ReactNode;
  centered?: boolean;
  width?: string;
}

const CustomModal: React.FC<CustomModalProps> = ({
  show,
  onHide,
  title,
  children,
  footer,
  centered = true,
  width = 'w-full'
 
}) => {
  if (!show) return null;

  

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center  bg-gray-500 bg-opacity-30">
      <div className="absolute inset-0" onClick={onHide} />
      <div className={`relative bg-white rounded-lg shadow-lg p-6 ${width} mx-4 flex flex-col max-h-[90vh]`}>
        {/* Header */}
        <div className="flex justify-between items-center mb-4 flex-shrink-0">
          <h3 className="text-xl font-semibold text-gray-900">{title}</h3>
          <button
            onClick={onHide}
            className="p-1.5 hover:bg-gray-100 text-gray-500 rounded-full transition-colors"
            aria-label="Close"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Body */}
        <div className="flex justify-center w-full items-start overflow-hidden min-h-0 flex-1">
          {children}
        </div>

        {/* Footer */}
        {footer && (
          <div className="flex justify-end gap-3 pt-4 border-t border-gray-200">
            {footer}
          </div>
        )}
      </div>
    </div>
  );
};

export default CustomModal; 